import React from 'react'
import Dialog from '@mui/material/Dialog'
import { Button } from '@mui/material'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'

const CustomConfirm = ({ open, onClose, onClickNG, onClickOK, message }) => {
  return (
        <Dialog open={open} onClose={onClose}>
            <DialogContent>
                <DialogContentText>
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClickNG} color="primary">キャンセル</Button>
                <Button onClick={onClickOK} color="primary">続行</Button>
            </DialogActions>
        </Dialog>
  );
}

export default CustomConfirm